// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"47":"client","818":"auth"}[chunkId] + "." + {"47":"4b938947","818":"a3cd82be"}[chunkId] + ".css";
};